import React, { useState, useEffect } from 'react';
import './DashboardSplash.css';

interface DashboardSplashProps {
  username: string;
  onComplete: () => void;
}

const DashboardSplash: React.FC<DashboardSplashProps> = ({ username, onComplete }) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Show splash for 2.5 seconds, then transition out
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => {
        onComplete();
      }, 600); // Match exit animation duration
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="splash-container">
      {/* Ambient particles */}
      <div className="splash-particles">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="splash-particle" />
        ))}
      </div>

      <div className={`splash-content ${isExiting ? 'exiting' : ''}`}>
        <img src="/bolt-full.svg" alt="Volt Logo" className="splash-logo" />
        
        <p className="splash-welcome">Welcome back</p>
        <h1 className="splash-username">{username}</h1>
        
        <div className="splash-loader">
          <div className="loader-bar-container">
            <div className="loader-bar" />
          </div>
          <p className="loader-text">
            Loading your dashboard
            <span className="loader-dots">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DashboardSplash;
